import { FunctionComponent } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { TabProp } from '~/components/Tabs'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { PureAdmContextTabs } from './PureAdmContextTabs'

type TabLabel = 'Contexts' | 'Context keys'

const contextTabs: TabProp[] = [
  { label: 'Contexts', trackingLabel: 'adm-contexts-tab-apply' },
  { label: 'Context keys', trackingLabel: 'adm-context-keys-tab-apply' },
]

const tabLabelToPath: { [key in TabLabel]: string } = {
  Contexts: 'contexts',
  'Context keys': 'context-keys',
}

export const AdmContextTabs: FunctionComponent = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const tabLabelFromLocation = (Object.keys(tabLabelToPath) as Array<keyof typeof tabLabelToPath>).find(
    (key) => tabLabelToPath[key] === (location.pathname.split('/').find((dir) => Object.values(tabLabelToPath).includes(dir)) ?? 'contexts')
  )

  const activeTab: TabLabel = tabLabelFromLocation ?? 'Contexts'

  const breadcrumbs = useBreadcrumbs()

  return (
    <PureAdmContextTabs
      breadcrumbs={breadcrumbs}
      onTabClick={(tab) => {
        navigate(tabLabelToPath[tab.label as TabLabel])
      }}
      tabs={contextTabs.map((t) => ({ ...t, active: t.label === activeTab }))}
    >
      <Outlet />
    </PureAdmContextTabs>
  )
}
